import { formatSentenceCase } from 'src/interviews/utils/formatTitleCasing';
import { IDiagnosis, IInterviewResults } from 'src/packages/polaris/types';

/** Bit of a hack to massage potential condition data to display correctly as a dx card */
export const buildDifferentialFromPotentialCondition: (
  result: IInterviewResults,
) => IDiagnosis | null = (result) => {
  const { triage_explanation: triageExplanation, triage } = result;
  const potentialCondition = triageExplanation?.potential_condition;

  if (!potentialCondition) {
    return null;
  }

  return {
    ...potentialCondition,
    name: formatSentenceCase(potentialCondition.name),
    token: '',
    duration: '',
    test: null,
    rarity: '',
    diagnosis_incidence: '',
    could_explain_list: [],
    could_explain: triageExplanation?.explanation,
    cant_explain: '',
    cant_explain_list: [],
    denied_could_explain_list: [],
    is_dxoc_match: true,
    usually_causes: '',
    belief: 'possible match',
    advice: {},
    triage,
    predictor: 0,
  };
};
